export const JOB_LIST_REQUEST_INITIATED = 'JOB_LIST_REQUEST_INITIATED';
export const JOB_LIST_REQUEST_SUCCESS = 'JOB_LIST_REQUEST_SUCCESS';
export const JOB_LIST_REQUEST_FAILED = 'JOB_LIST_REQUEST_FAILED';
export const SEARCH_JOB_LIST_REQUEST_INITIATED = 'SEARCH_JOB_LIST_REQUEST_INITIATED';
export const SEARCH_JOB_LIST_REQUEST_SUCCESS = 'SEARCH_JOB_LIST_REQUEST_SUCCESS';
export const SEARCH_JOB_LIST_REQUEST_FAILED = 'SEARCH_JOB_LIST_REQUEST_FAILED';